import React, { FC } from 'react';
import Button from '@lt/components/components/ButtonTs';
import styled from 'styled-components';

export const ApplyButton: FC<React.HTMLProps<HTMLButtonElement>> = ({
  children,
  onClick,
  disabled,
}) => (
  <StyledButton disabled={disabled} size="large" offHover onClick={onClick}>
    {children}
  </StyledButton>
);

const StyledButton = styled(Button)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: inherit;
    margin: 0 auto;
    background-color: #007aff;
    border: none;
    color: #fff;
    font-size: 14px;
    transition: 0.3s;
    padding: 0 16px;

    &:hover {
      transform: scale(1.02);
    }
  }
`;
